import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Moment from "moment";
import { COMPULSORY_SCHOOL, PRESCHOOL, UPPER_SECONDARY_EDUCATION, ADULT_EDUCATION } from "constants/schoolTypes";
import { addError } from "actions";
import { setPageTitle } from "actions/header";
import { getGuardianStudentGroup } from "actions/sections";
import { getReaderParameters } from "actions/user";
import { getGoals } from "actions";
import { getBlocksByReference } from "actions/blocks";
import { getGuardianStudentPlan, getGuardianStudentPlanAssessments } from "actions/planning";
import { getImmersiveReaderDataFromBlocks } from "helpers/content";
import DateSpan from "components/Presentation/Dates/DateSpan";
import BlockConsumer from "components/BlockEditor/Consumer";
import AssessmentsConsumer from "components/BlockAssessments/Consumer";
import Message from "containers/SinglePages/Partials/Message";
import SelectedCoreContent from "../CoreContent/Selected";
import PurposeConsumer from "components/BlockPurpose/Index";
import { Block as ContentBlock, Button, getActiveLanguage, translate } from "@haldor/ui";
import { Expandable, Spinner } from "UI";
import { Immersive_Reader } from "UI/Icons";
var ImmersiveReader = require("@microsoft/immersive-reader-sdk");
var singlePlan = /*#__PURE__*/function (_Component) {
  function singlePlan(props) {
    var _this;
    _classCallCheck(this, singlePlan);
    _this = _callSuper(this, singlePlan, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var activeStudent = _this.props.activeStudent;
      _this.props.getGuardianStudentPlan(activeStudent.id, _this.props.match.params.planId).then(function () {
        _this.props.setPageTitle(_this.props.activePlan.title);
        _this.props.getGuardianStudentGroup(activeStudent.id, _this.props.activePlan.sectionId);
        _this.props.getGuardianStudentPlanAssessments(_this.props.match.params.planId);
        _this.props.getBlocksByReference(_this.props.match.params.planId, "PLAN").then(function () {
          _this.setState({
            loadingBlocks: false
          });
        });
      })["catch"](function (error) {
        if (error.response && error.response.status === 400 || error.response.status === 404) {
          _this.setState({
            loadingBlocks: false
          });
          _this.setState({
            errorMessage: _this.props.translate('No planning was found')
          });
        }
      });
      if (_this.props.goals.length < 1) {
        _this.props.getGoals();
      }
    });
    _defineProperty(_this, "onConversationClose", function () {
      _this.setState({
        studentConversation: null
      });
    });
    _defineProperty(_this, "openConversation", function () {
      _this.setState({
        studentConversation: _this.props.activeStudent
      });
    });
    _defineProperty(_this, "assignmentIndicator", function (status) {
      var translate = _this.props.translate;
      if (status === "PLANNING_OPEN") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-green"
        }, translate("Open"));
      } else if (status === "PLANNING_CLOSED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-red"
        }, translate("Closed"));
      } else if (status === "PLANNING_DRAFT") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-gray"
        }, translate("Draft"));
      }
      return null;
    });
    _defineProperty(_this, "pupilStatus", function (status) {
      var translate = _this.props.translate;
      if (status === "PLANNING_OPEN") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-green"
        }, translate("Open"));
      } else if (status === "PLANNING_CLOSED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-red"
        }, translate("Closed"));
      } else if (status === "ASSESSMENT_PUBLISHED") {
        return /*#__PURE__*/React.createElement("span", {
          className: "single-dot dot-green"
        }, translate("Assessed"));
      }
      return /*#__PURE__*/React.createElement("span", {
        className: "single-dot dot-red"
      }, translate("Closed"));
    });
    _defineProperty(_this, "runImmersiveReader", function () {
      var activePlan = _this.props.activePlan;
      var data = getImmersiveReaderDataFromBlocks(activePlan.title, _this.props.blocks);
      _this.props.getReaderParameters().then(function () {
        var reader = _this.props.reader;
        ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
          uiLang: getActiveLanguage()
        })["catch"](function (error) {
          console.error("error", error);
          //trackImmersiveReaderError(error, currentUser.id);
        });
      });
    });
    _defineProperty(_this, "readPlanInformation", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props, activePlan, currentUser, translate, localLanguage, reader, start, end, status, data;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this$props = _this.props, activePlan = _this$props.activePlan, currentUser = _this$props.currentUser, translate = _this$props.translate;
            localLanguage = localStorage.getItem("language");
            _context.next = 1;
            return _this.props.getReaderParameters();
          case 1:
            reader = _this.props.reader;
            if (!(reader == null)) {
              _context.next = 2;
              break;
            }
            return _context.abrupt("return");
          case 2:
            start = Moment.utc(activePlan.timeStart).local().format("D MMM");
            end = Moment.utc(activePlan.timeEnd).local().format("D MMM");
            status = translate("open");
            if (activePlan.status == "PLANNING_CLOSED") {
              status = translate("closed");
            }
            if (activePlan.status == "PLANNING_DRAFT") {
              status = translate("draft");
            }
            data = {
              title: activePlan.title,
              chunks: [{
                content: "<h3>\n\t\t\t\t\t\t".concat(translate("Plan information"), "\n\t\t\t\t\t</h3>"),
                mimeType: "text/html"
              }, {
                content: "\n\t\t\t\t\t\t".concat(translate("Plan is active between"), ":\n\t\t\t\t\t\t").concat(start, " - ").concat(end, " and the current status is: ").concat(status, "\n\t\t\t\t\t\t</br>\n\t\t\t\t\t"),
                mimeType: "text/html"
              }]
            };
            ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
              uiLang: localLanguage // Set immersive reader UI language to selected lang in Haldor Edu
            })["catch"](function (error) {
              console.error("error", error);
              trackImmersiveReaderError(error, currentUser.id);
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "planContent", function () {
      var _this$props$activePla;
      var conversation = null;
      if (_this.props.conversations != null && _this.props.user != null) {
        conversation = _this.props.conversations.find(function (conv) {
          return conv.memberships.find(function (member) {
            return member.membershipID == _this.props.user.id;
          });
        });
      }
      var assessmentBlocks = [];
      var assessment = null;
      if (_this.props.blocks != null) {
        assessmentBlocks = _toConsumableArray(_this.props.blocks).filter(function (block) {
          return block.type == "Haldor.Blocks.AssessmentBlock";
        });
      }
      if (_this.props.assessments != null) {
        assessment = _this.props.assessments.find(function (assessment) {
          return assessment.studentId == _this.props.activeStudent.id;
        });
      }
      var _this$props2 = _this.props,
        translate = _this$props2.translate,
        activeSection = _this$props2.activeSection;
      var conversationEnabled = false;
      if (activeSection !== null && activeSection !== void 0 && activeSection.owners && (activeSection === null || activeSection === void 0 ? void 0 : activeSection.owners.length) > 0) {
        conversationEnabled = _this.hasValidOwner(activeSection.owners, _this.props.activePlan.creator, activeSection.schoolID.toString());
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "single-plan single-task",
        key: _this.props.activePlan.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: _this.props.translate("Planning information"),
        open: true
      }, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.readPlanInformation
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), _this.props.translate("Immersive Reader"))), /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate("Status")), /*#__PURE__*/React.createElement("div", null, _this.props.activePlan.studentStatus == "ASSESSMENT_PUBLISHED" ? /*#__PURE__*/React.createElement("span", {
        className: "single-dot dot-green"
      }, translate("Assessed")) : _this.assignmentIndicator(_this.props.activePlan.status), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate("Information")), /*#__PURE__*/React.createElement(DateSpan, {
        start: _this.props.activePlan.timeStart,
        end: _this.props.activePlan.timeEnd
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), _this.props.activeStudent != null && _this.props.activeStudent.services.conversations && conversationEnabled ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: _this.openConversation,
        style: {
          marginTop: "1rem",
          position: "relative"
        }
      }, translate("Conversation"), conversation != null && conversation.unreadMessages > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "badge"
      }, /*#__PURE__*/React.createElement("span", null, conversation.unreadMessages)) : null) : null, _this.props.activePlan.courses.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem"
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, _this.props.translate("Subject_course")), /*#__PURE__*/React.createElement("div", {
        className: "courses"
      }, _this.props.activePlan.courses.map(function (course) {
        var text = course.title;
        if (course.year != null) {
          text += " " + course.year;
        }
        return /*#__PURE__*/React.createElement("div", {
          className: "course",
          key: 'course' + course.id
        }, /*#__PURE__*/React.createElement("span", {
          className: "indicator",
          style: {
            backgroundColor: course.colorCode
          }
        }), text);
      }))) : null))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), _this.props.blocks != null ? /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: translate("Content"),
        open: true
      }, _this.state.loadingBlocks ? /*#__PURE__*/React.createElement(Spinner, {
        center: true
      }) : /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "#",
        onClick: _this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), " ", translate("Immersive Reader"))), /*#__PURE__*/React.createElement(BlockConsumer, {
        fields: _this.props.blocks
      })))) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section-divider"
      }), (_this$props$activePla = _this.props.activePlan) !== null && _this$props$activePla !== void 0 && _this$props$activePla.viewablePurpose && assessmentBlocks.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          marginBottom: "1em",
          fontWeight: 600,
          fontSize: "1.625em"
        }
      }, _this.props.translate('Purpose')), /*#__PURE__*/React.createElement(PurposeConsumer, {
        assessmentBlocks: assessmentBlocks
      })) : null, _this.props.activeStudent != null && _this.props.activeStudent.services.conversations ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(Message, {
        plan: _this.props.activePlan,
        activeUser: _this.state.studentConversation,
        onClose: _this.onConversationClose
      })) : null, _this.props.activePlan.viewableCoreContent && _this.props.activePlan.associatedCoreContents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          fontWeight: 600,
          fontSize: "1.625em"
        }
      }, translate("Subject/Lesson content")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectedCoreContent, {
        coreContent: _this.props.activePlan.associatedCoreContents
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(AssessmentsConsumer, {
        fields: assessmentBlocks,
        assessment: assessment
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }));
    });
    var planid = false;
    if (parseInt(_this.props.match.params.planId) > 0) {
      planid = parseInt(_this.props.match.params.planId);
    }
    _this.state = {
      id: planid,
      studentConversation: null,
      loadingBlocks: true,
      errorMessage: null
    };
    return _this;
  }
  _inherits(singlePlan, _Component);
  return _createClass(singlePlan, [{
    key: "hasNonStudentRole",
    value: function hasNonStudentRole(roles, referenceId) {
      return roles.some(function (role) {
        return role.referenceId === referenceId && role.roleId.toLowerCase() !== "student";
      });
    }
  }, {
    key: "hasValidOwner",
    value: function hasValidOwner(sectionOwners, creatorId, referenceId) {
      var _this2 = this;
      return sectionOwners.some(function (user) {
        return user.userId === creatorId && _this2.hasNonStudentRole(user.roles, referenceId);
      });
    }
  }, {
    key: "preschoolPlan",
    value: function preschoolPlan() {
      var _this3 = this;
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "single-plan single-task",
        key: this.props.activePlan.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "single-section form left-side"
      }, /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate("Planning information"),
        open: true
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: this.readPlanInformation
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), this.props.translate("Immersive Reader"))), /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate("Status")), /*#__PURE__*/React.createElement("div", null, this.props.activePlan.studentStatus == "ASSESSMENT_PUBLISHED" ? /*#__PURE__*/React.createElement("span", {
        className: "single-dot dot-green"
      }, translate("Assessed")) : this.assignmentIndicator(this.props.activePlan.status), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      })), /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate("Information")), /*#__PURE__*/React.createElement(DateSpan, {
        start: this.props.activePlan.timeStart,
        end: this.props.activePlan.timeEnd
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: "both"
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "title",
        style: {
          marginTop: "1rem"
        }
      }, translate("Goals")), this.props.activePlan.associatedGoals && this.props.activePlan.associatedGoals.length > 0 ? /*#__PURE__*/React.createElement("div", null, this.props.activePlan.associatedGoals.map(function (associatedGoal) {
        var goal = _this3.props.goals.find(function (t) {
          return t.id == associatedGoal.goalId;
        });
        if (goal != null) {
          return /*#__PURE__*/React.createElement("div", {
            key: goal.id,
            "data-tooltip": goal.text,
            className: "goal-preview",
            style: {
              backgroundColor: goal.colorCode
            }
          }, goal.title);
        }
        return null;
      })) : null))), /*#__PURE__*/React.createElement("div", {
        className: "single-actions right-side"
      }), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), this.props.blocks != null ? /*#__PURE__*/React.createElement(ContentBlock, null, /*#__PURE__*/React.createElement(Expandable, {
        title: translate("Content"),
        open: true
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: this.runImmersiveReader
      }, /*#__PURE__*/React.createElement("div", {
        className: "reader trigger"
      }, /*#__PURE__*/React.createElement(Immersive_Reader, null), " ", translate("Immersive Reader"))), /*#__PURE__*/React.createElement(BlockConsumer, {
        fields: this.props.blocks
      }))) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      if (this.props.students == null) {
        return /*#__PURE__*/React.createElement("div", null);
      } else {
        if (this.props.activePlan != null && this.props.activeSection != null) {
          var activeStudent = this.props.activeStudent;
          var school = activeStudent.schools.find(function (school) {
            return school.id == _this4.props.activeSection.schoolID;
          });
          if (school == null) return /*#__PURE__*/React.createElement("div", null);
          switch (school.type) {
            case PRESCHOOL:
              return this.preschoolPlan();
              break;
            case COMPULSORY_SCHOOL:
              return this.planContent();
              break;
            case UPPER_SECONDARY_EDUCATION:
              return this.planContent();
              break;
            case ADULT_EDUCATION:
              return this.planContent();
              break;
            default:
              return /*#__PURE__*/React.createElement("div", null);
              break;
          }
        } else {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              display: "flex",
              justifyContent: "center",
              margin: "1rem"
            }
          }, this.state.errorMessage ? /*#__PURE__*/React.createElement("div", {
            style: {
              width: "100%",
              textAlign: "center",
              fontWeight: "500",
              color: "#9f9f9f",
              backgroundColor: "white",
              padding: "2rem",
              boxShadow: "0 5px 15px #0000000d",
              borderRadius: "3px"
            }
          }, this.state.errorMessage) : null, this.state.loadingBlocks && !this.state.errorMessage ? /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }) : "");
        }
      }
    }
  }]);
}(Component);
var mapStateToProps = function mapStateToProps(state) {
  return {
    user: state.User.user,
    activePlan: state.planning.plan,
    activeStudent: state.User.activeStudent,
    activeSection: state.groups.activeGroup,
    assessments: state.planning.assessments,
    students: state.guardians.students,
    goals: state.base.goals,
    conversations: state.Conversation.referenceConversations,
    reader: state.User.reader,
    translate: translate(state.Languages.translations),
    blocks: state.Blocks.reference
  };
};
var mapDispatchToProps = {
  getGuardianStudentPlan: getGuardianStudentPlan,
  addError: addError,
  getGuardianStudentPlanAssessments: getGuardianStudentPlanAssessments,
  getGuardianStudentGroup: getGuardianStudentGroup,
  getReaderParameters: getReaderParameters,
  setPageTitle: setPageTitle,
  getGoals: getGoals,
  getBlocksByReference: getBlocksByReference
};
export default connect(mapStateToProps, mapDispatchToProps)(singlePlan);